/*
This file contains a simple react component that handles the e-conomic redirect URL.

We will fetch the token from the URL and create a new e-conomic integration for the user.
If no integration exists, that is.

We will also trigger the first synchronization of the integration.
While we wait for feedback that the synchronization is done, we will show a loading spinner.

Once the synchronization is done, we will redirect the user to the prompt.
*/
import { useEffect, useState } from "react";
import {
  Box,
  CircularProgress,
  Grid,
  InputLabel,
  Typography,
} from "@mui/material";
import axios from "../../utils/axios";

function syncIntegration(integration_identifier: string = "economic") {
  //return new Promise((resolve) => {
  //  setTimeout(() => {
  //    resolve();
  //  }, 3000);
  //});
  return axios.post(
    "/v1/integrations/sync/",
    JSON.stringify({ integration_identifier: integration_identifier }),
    { withCredentials: true },
  );
}

const EconomicConnect = () => {
  const [creatingIntegration, setCreatingIntegration] = useState(false);
  const [syncingIntegration, setSyncingIntegration] = useState(false);
  const [synced, setSynced] = useState(false);

  function sleep(ms: number) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  useEffect(() => {
    const economicToken = localStorage.getItem("economicToken");

    const createIntegration = async () => {
      if (economicToken) {
        try {
          setCreatingIntegration(true);
          const response = await axios.post(
            "/v1/integrations/create-integration/",
            JSON.stringify({ identifier: "economic", secret: economicToken }),
            { withCredentials: true },
          );

          if (response.status === 200) {
            setCreatingIntegration(false);
            setSyncingIntegration(true);
            await syncIntegration();
            setSyncingIntegration(false);
            setSynced(true);
            await sleep(3000);
            window.location.href = "/";
          }
        } catch (error) {
          console.error("Error creating integration:", error);
        }
      }
    };

    createIntegration();
  }, []);

  return (
    <Box sx={{ bgcolor: "secondary.main" }}>
      <Grid container direction="row" spacing={3} alignContent="center">
        <Grid size={{ xs: 12, lg: 12 }}>
          <InputLabel sx={{ marginBottom: "3%", marginTop: "4%" }}>
            Connecting to e-conomic
          </InputLabel>
          <CircularProgress></CircularProgress>
          <Typography sx={{ marginTop: "1.5%", marginBottom: "1.5%" }}>
            {creatingIntegration && "Creating integration..."}
            {syncingIntegration && "Synchronization in progress..."}
            {synced && "Synchronization done, redirecting..."}
          </Typography>
        </Grid>
      </Grid>
    </Box>
  );
};

export default EconomicConnect;
